export const managerMenuLinks = [
    
    {
        "label": "menu.dashboard",
        "link": "/dashboard",
        "submenu": [
            {
                "label": "menu.devicesSummary",
                "link": "/dashboard/summary-dashboard"
            },
            {
                "label": "menu.mobileDevices",
                "link": "/dashboard/deviceslist/mobile-devices"
            },
            {
                "label": "menu.accessPoints",
                "link": "/dashboard/aps"
            },
            {
                 "label": "menu.productivity",
                "link": "/dashboard/productivity"
            }
        ]
    },
    {
        "label": "report.reports",
        "link": "/reports",
        "dividerNeeded": true,
        "submenu": [
            {
                "label": "report.eventsBySite",
                "link": "/reports/daily-event-detail-report"
            },
            {
                "label": "eodDeviceSummary",
                "link": "/reports/end-of-day-summary"
            }
        ]
    },
    {
        "label": "menu.about",
        "link": "/about",
        "dividerNeeded": true
    }

];

